// @ts-expect-error
tinymce.PluginManager.add("kbModuleLink", function (editor, url) {
	const openDialog = () => {
		$.ajax({
			type: "GET",
			url: "/kb_modules/load_module_contents_for_link_select",
			dataType: "json",
			success: function (data) {
				const contentTitles = [];
				for (const [id, title] of Object.entries(data)) {
					contentTitles.push({ text: title, value: id });
				}
				return editor.windowManager.open({
					title: I18n.t("helpers.submit.new", {
						model: `${I18n.t("activerecord.models.kb_module", { count: 1 })}-Link`,
					}),
					body: {
						type: "panel",
						items: [
							{
								type: "selectbox",
								items: contentTitles,
								name: "kb_id",
								label: I18n.t("activerecord.models.kb_module.one"),
							},
							{
								type: "input",
								name: "btn_text",
								label: "Button text",
							},
						],
					},
					buttons: [
						{
							type: "cancel",
							text: I18n.t("global.actions.close"),
						},
						{
							type: "submit",
							text: I18n.t("global.actions.save"),
							primary: true,
						},
					],
					onSubmit: function (api) {
						const data = api.getData();
						// `href` of `javascript:;` somehow does not get added at all
						editor.insertContent(
							`<a href='#' data-kb-id='${data.kb_id}'>${data.btn_text}</a>`,
						);
						api.close();
					},
				});
			},
		});
	};
	/* Add a menu item that opens a window */
	editor.ui.registry.addMenuItem("kbModuleLink", {
		text: I18n.t("activerecord.models.kb_module", { count: 1 }) + "…",
		icon: "link",
		onAction: openDialog,
	});
});
